import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ORG_TYPE_URL, ORG_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import { useAlert } from "./../../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function OrgDialog({ orgId, data, selectedOrgName, callOrgs, isEdit }) {
  const [open, setOpen] = React.useState(false);

  const [orgTypeId, setOrgTypeId] = useState();
  const [orgTypeData, setOrgTypeData] = useState([]);
  const [orgTypeName, setOrgTypeName] = useState();
  const [orgParentOrgId, setOrgParentOrgId] = useState();
  const [timeZone, setTimeZone] = useState();
  const [orgName, setOrgName] = useState("");
  const [orgWebSite, setOrgWebSite] = useState("");
  const [orgIsParentChecked, setOrgIsParentChecked] = useState(false);
  const [notes, setNotes] = useState("");
  const [isDisable, setIsDisable] = useState(true);
  const timeZones = moment.tz.names();
  const showAlert = useAlert();


  useEffect(() => {
    getOrgTypes();
  }, []);

  const getOrgTypes = () => {
    AxiosInstance.get(ORG_TYPE_URL).then((response) =>
      setOrgTypeData(response.data)
    );
  };

  const getOrgnization = () => {
    AxiosInstance.get(ORG_URL + "/" + orgId).then((response) => {
      var orgData = response.data.data;
      setOrgName(orgData.name);
      setOrgTypeId(orgData.organizationType ?.id);
      setOrgWebSite(orgData.webSite);
      setOrgIsParentChecked(orgData.parent);
      setOrgParentOrgId(orgData.parentOrganizationId);
      setTimeZone(orgData.timeZone);
      setNotes(orgData.notes);
      setOpen(true);
    });
  };

  const handleClickOpen = () => {
    if (isEdit) {
      getOrgnization();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOrgTypeChange = (event) => {
    setOrgTypeId(event.target.value);
  };

  const handleOrgNameChange = (event) => {
    setOrgName(event.target.value);
  };

  const handleOrgWebSiteChange = (event) => {
    setOrgWebSite(event.target.value);
  };

  const handleOrgIsParentCheckedChange = (event) => {
    if (event.target.checked) {
      setIsDisable(false);
      setOrgIsParentChecked(true);
    } else {
      setIsDisable(true);
      setOrgIsParentChecked(false);
      setOrgParentOrgId("");
    }
  };

  const handleParentOrgChange = (event) => {
    setOrgParentOrgId(event.target.value);
  };

  const handleTimeZoneChange = (event) => {
    setTimeZone(event.target.value);
  };

  const handleNotesChange = (event) => {
    setNotes(event.target.value);
  };

  const handleSave = () => {
    const payload = {};
    payload.name = orgName;
    payload.organizationType = { id: orgTypeId };
    payload.webSite = orgWebSite;
    payload.parent = orgIsParentChecked;
    payload.parentOrganizationId = orgParentOrgId;
    payload.timeZone = timeZone;
    payload.notes = notes;

    if (isEdit) {
      updateOrg(payload);
    } else {
      createOrg(payload);
    }
  };

  const createOrg = (payload) => {

    AxiosInstance.post(ORG_URL, payload)
      .then((response) => {
        showAlert("Organization created successfully!", "success");
        callOrgs();
      })
      .catch((error) => {
        showAlert("Organization creation failed!", "error");
        console.error(error);
      });
  };

  const updateOrg = async (payload) => {
    await AxiosInstance.put(`${ORG_URL}/${orgId}`, payload)
      .then((response) => {
        showAlert("Organization updated successfully!", "success");
        callOrgs();
      })
      .catch((error) => {
        showAlert("Organization updation failed!", "error");
        console.error(error);
      });
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        {isEdit === false ? (
          <>       
          < Tooltip
            title="Add Org"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px", float: "right" }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
          </>
  ) : (
    <Link onClick={handleClickOpen}>{selectedOrgName}</Link>
        )
}

<Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              handleSave();
              handleClose();
            },
          }}
        >
          <DialogTitle>Add Organization</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiTextField-root": { m: 1 } }}
              noValidate
              autoComplete="off"
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="outlined-multiline-static"
                name="Organization"
                label="Organization"
                type="text"
                variant="outlined"
                fullWidth
                value={orgName}
                onChange={handleOrgNameChange}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="outlined-multiline-static"
                name="Website"
                label="Website"
                type="text"
                fullWidth
                variant="outlined"
                value={orgWebSite}
                onChange={handleOrgWebSiteChange}
              />
              <br />

              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Org Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={orgTypeId}
                  onChange={handleOrgTypeChange}
                  label="Org Type"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {orgTypeData.map((orgType) => (
                    <MenuItem value={orgType.id}>{orgType.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Time Zone
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={timeZone}
                  onChange={handleTimeZoneChange}
                  label="Time Zone"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {timeZones.map((tz) => (
                    <MenuItem value={tz}>{tz}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br />

              <FormControlLabel
                variant="outlined"
                checked={orgIsParentChecked}
                onChange={handleOrgIsParentCheckedChange}
                control={<Checkbox />}
                sx={{ m: 1, minWidth: 180, verticalAlign: "bottom" }}
                label="Is Parent"
              />
              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Parent Orgnization
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={orgParentOrgId}
                  onChange={handleParentOrgChange}
                  label="Parent Orgnization"
                  disabled={!orgIsParentChecked}
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {data ?.map((org) => (
                    <MenuItem value={org.id}>{org.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br />

              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="name"
                label="Notes"
                placeholder="Enter Notes"
                fullWidth
                multiline
                rows={4}
                cols={10}
                value={notes}
                onChange={handleNotesChange}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            {orgId !== 0 ? <Button type="submit">Update </Button> : <Button type="submit">Add </Button>}

          </DialogActions>
        </Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default OrgDialog;
